export default function genererAdresse() {
  return {
    adresse1: null,
    adresse2: null,
    adresse3: null,
    pays: null,
    ville: null,
    codePostal: null,
    departement: null,
    agglomeration: null,
    intitule1: null,
    intitule2: null,
    intitule3: null,
    latitude: 0,
    longitude: 0,
  };
}



// WEBPACK FOOTER //
// ./src/services/general/genererAdresse.js